import safeCreateAction from "../../actions/safeCreateAction";
export const setLayout = safeCreateAction("SET_LAYOUT", (layout) => layout);
export const setDashletEnabled = safeCreateAction("SET_WIDGET_ENABLED", (widgetId, enabled) => ({ widgetId, enabled }));
export const setDashletWidth = safeCreateAction("SET_WIDGET_WIDTH", (widgetId, width) => ({ widgetId, width }));
export const setDashletHeight = safeCreateAction("SET_WIDGET_HEIGHT", (widgetId, height) => ({ widgetId, height }));
